import PropTypes from 'prop-types';
import React, {Suspense, useCallback, useEffect, useRef, useState} from 'react';

import { ApplicationContext } from '@product-site-frontend/shared';
import { AzFormApplication, AzModal } from "@Development/ui-kit";
import { leasingFormGoToLK, leasingFormLoadFullForm, leasingFormGoToTid } from "../utils/metrics";
import { EQUIPMENT_TYPE } from "./Layout";
import { arenzaStorage } from '../core/storage';
import qs from "querystringify";
import getAppTrackingParams from "../utils/getTrackingParams";
import { leasingFormLoad } from "../utils/metrics";

LayoutApplicationContext.propTypes = {
  children: PropTypes.node,
};

export default function LayoutApplicationContext({ children }) {
  const [applicationOpen, setApplicationOpen] = useState(false);
  const [amount, setAmount] = useState('');
  const [term, setTerm] = useState('');
  const [advanceRate, setAdvanceRate] = useState('');

  const contextValue = {
    data: {
      amount,
      applicationOpen,
      inn: '',
      phone: '',
      full_name: '',
      email: '',
      promo_code: '',
    },
    setApplicationOpen: (isOpen) => {setApplicationOpen(isOpen)},
    setAmount: (amnt) => {setAmount(amnt)},
    setTerm: (trm) => setTerm(trm),
    setAdvanceRate: (advancePayment) => setAdvanceRate(advancePayment),
  };

  const closeApplicationDialog = useCallback(() => {
        setApplicationOpen(false);
    }, [setApplicationOpen]
  );

    const utm_source = useRef(null);
    const utm_full = useRef(null);

    let utmLocation = arenzaStorage.session('utmTagsInUrl');

    const [channel, setChannel] = useState('');

    useEffect(() => {
        if (localStorage.getItem('_ym_uid')) {
            const yuid = localStorage.getItem('_ym_uid').replaceAll('"', '');

            if (utmLocation?.includes('?')) {
                utmLocation += `&ym_uid=${yuid}`
            } else {
                utmLocation += `?ym_uid=${yuid}`
            }
        }

        if (window?.Comagic) {
            const comagicId = window.Comagic.getVisitorId();

            if (utmLocation?.includes('?')) {
                utmLocation += `&comagic_id=${comagicId}`
            } else {
                utmLocation += `?comagic_id=${comagicId}`
            }
        }

        if (utmLocation.includes('utm_source')) {
            let urlParam = qs.parse(utmLocation);

            utm_source.current = urlParam.utm_source;
        }

        utm_full.current = utmLocation;

        const { channel: chn } = getAppTrackingParams(utm_full.current);
        setChannel(chn)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {
        if (applicationOpen && window) {
            leasingFormLoad();
        }
    }, [applicationOpen])

  return (
    <ApplicationContext.Provider value={contextValue}>
        {children}

        {applicationOpen && (
            <Suspense>
                <AzModal animationSlide={true} onClose={closeApplicationDialog} smallCloseZone={true}>
                    <AzFormApplication
                        propertyType={arenzaStorage(EQUIPMENT_TYPE)}
                        tidRedirectUrl={`${process.env.GATSBY_ACCOUNT_URL}/`}
                        tidState={utm_full?.current || undefined}
                        urlAccountClient={process.env.GATSBY_ACCOUNT_URL}
                        urlFrontOfficeBackend={process.env.GATSBY_FRONTOFFICE_API}
                        channel={channel}
                        amount={amount.toString()}
                        term={+term}
                        advanceRate={+advanceRate}
                        landing_url={utm_full.current || undefined}
                        eventsLeasingFormGoToLK={leasingFormGoToLK}
                        eventsLeasingFormGoToTid={leasingFormGoToTid}
                        eventsLeasingFormLoadFullForm={leasingFormLoadFullForm}
                    />
                </AzModal>
            </Suspense>
        )}


    </ApplicationContext.Provider>
  )
}
